var map = {
	"./contribute/index.md": 6221,
	"./design/iconography.md": 19449,
	"./user documentation/create a page.md": 77609,
	"./user documentation/index.md": 3875,
	"./user documentation/reports.md": 10996,
	"./user documentation/wordpress.md": 85584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55160;